module.exports = __webpack_public_path__ + "img/LDSJ_STILL16.a2fa6f21.jpg";